export default __webpack_public_path__ + "media/images/portfolio/gallery-02-370x220-5950e1b04cb273234275a89182febb3e.jpg";